<h6 class="rv-sidebar-heading">
  <div class="content">
    <span class="filter-title"><ng-content></ng-content></span>
    <a *ngIf="clearable" class="rv-link" (click)="clear.next(undefined)"
      >Remove</a
    >
  </div>
</h6>
